module.exports = __webpack_public_path__ + "img/replace.e7f4f3c5.svg";